import { useEffect, useState } from "react";

const navLinks = [
  { href: "#today", label: "今日更新" },
  { href: "#hot", label: "热门连载" },
  { href: "#reminder", label: "追更提醒" },
  { href: "#category", label: "题材分类" },
  { href: "#faq", label: "追更FAQ" },
  { href: "#about", label: "关于我们" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-background-50/95 backdrop-blur border-b border-background-200" : "bg-transparent"
      }`}
    >
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="flex items-center justify-between h-16 md:h-[72px]">
          {/* logo */}
          <a href="#top" className="flex items-center gap-2 shrink-0 cursor-pointer">
            <span className="flex items-center justify-center w-9 h-9 md:w-10 md:h-10 rounded-full bg-primary-500 text-background-50 font-heading text-lg md:text-xl">
              追
            </span>
            <span className={`font-heading text-xl md:text-2xl ${scrolled ? "text-primary-700" : "text-background-50"}`}>
              51漫画追更
            </span>
          </a>

          {/* desktop nav */}
          <nav className="hidden md:flex items-center gap-6 lg:gap-8" aria-label="主导航">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className={`text-sm font-medium whitespace-nowrap cursor-pointer transition-colors ${
                  scrolled ? "text-foreground-700 hover:text-primary-600" : "text-background-50/90 hover:text-background-50"
                }`}
              >
                {link.label}
              </a>
            ))}
          </nav>

          <div className="hidden md:flex items-center gap-3">
            <a
              href="#search"
              aria-label="搜索漫画"
              className={`flex items-center justify-center w-9 h-9 rounded-full cursor-pointer ${
                scrolled ? "bg-background-100 text-foreground-700 hover:text-primary-600" : "bg-background-50/15 text-background-50"
              }`}
            >
              <i className="ri-search-line text-lg" />
            </a>
            <a
              href="#today"
              className="inline-flex items-center whitespace-nowrap rounded-full bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium px-5 py-2.5 transition-colors cursor-pointer"
            >
              开始追更
            </a>
          </div>

          {/* mobile hamburger */}
          <button
            type="button"
            onClick={() => setOpen(!open)}
            aria-label="打开菜单"
            className={`md:hidden flex items-center justify-center w-10 h-10 rounded-full cursor-pointer ${
              scrolled ? "bg-background-100 text-foreground-900" : "bg-background-50/15 text-background-50"
            }`}
          >
            <i className={`${open ? "ri-close-line" : "ri-menu-line"} text-xl`} />
          </button>
        </div>
      </div>

      {/* mobile menu */}
      {open && (
        <div className="md:hidden bg-background-50 border-b border-background-200 px-4 py-4">
          <nav className="flex flex-col gap-1" aria-label="移动端导航">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setOpen(false)}
                className="py-2.5 px-3 rounded-lg text-sm text-foreground-800 hover:bg-background-100 hover:text-primary-600 cursor-pointer"
              >
                {link.label}
              </a>
            ))}
            <a
              href="#today"
              onClick={() => setOpen(false)}
              className="mt-2 inline-flex items-center justify-center whitespace-nowrap rounded-full bg-primary-500 text-background-50 text-sm font-medium px-5 py-2.5 cursor-pointer"
            >
              开始追更
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}